var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilterSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3201 19.5698C14.3201 20.1798 13.92 20.9798 13.41 21.2898L12.0001 22.1998C10.6901 23.0098 8.87006 22.0998 8.87006 20.4798V15.1298C8.87006 14.4198 8.47006 13.5098 8.06006 13.0098L4.22003 8.96976C3.71003 8.45976 3.31006 7.55977 3.31006 6.94977V4.62976C3.31006 3.41976 4.22008 2.50977 5.33008 2.50977H18.67C19.78 2.50977 20.6901 3.41975 20.6901 4.52975V6.74976C20.6901 7.55976 20.1801 8.56976 19.6801 9.06976",
    stroke: "#161719",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0701 17.0201C17.8374 17.0201 19.2701 15.5874 19.2701 13.8201C19.2701 12.0528 17.8374 10.6201 16.0701 10.6201C14.3028 10.6201 12.8701 12.0528 12.8701 13.8201C12.8701 15.5874 14.3028 17.0201 16.0701 17.0201Z",
    stroke: "#161719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8701 17.6201L18.8701 16.6201",
    stroke: "#161719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSearch);
export default __webpack_public_path__ + "static/media/filterSearch.c4caee8b45f350992a466822dd493b19.svg";
export { ForwardRef as ReactComponent };